import React from 'react';
import { Formik, Form as FormikForm } from 'formik';

const Form = FormikForm as unknown as React.ComponentType<
  React.PropsWithChildren<Record<string, unknown>>
>;

import { getTranslation } from 'helpers/getTranslation';

import { Drawer } from 'components/shared/Drawer';
import { Button } from 'components/shared/Button';
import { Loading } from 'components/shared/Loading';

import { FormikField } from 'components/FormikField';
import { SelectField } from 'components/FormikFields';

import { initialValues, validationSchema } from './CopySettings.formConfig';

import styles from './CopySettings.module.scss';

const CopySettings = ({
  open,
  loading,
  copyLoading,
  coursesOptions,
  modulesOptions,
  onClose,
  onCourseChanged,
  onCopyClick,
}: {
  open: any;
  loading: any;
  copyLoading: any;
  coursesOptions: any;
  modulesOptions: any;
  onClose: any;
  onCourseChanged: any;
  onCopyClick: any;
}) => (
  <Drawer open={open} headerContent="Copy settings" onClose={onClose}>
    {loading ? (
      <Loading />
    ) : (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onCopyClick}
      >
        {({ values }: { values: any }) => (
          <Form className={styles.form}>
            <div className={styles.inner}>
              <FormikField
                name="course"
                component={SelectField}
                componentProps={{
                  options: coursesOptions,
                  onChanged: onCourseChanged,
                }}
                controlProps={{
                  required: true,
                  label: 'Course',
                }}
              />
              <FormikField
                name="module"
                component={SelectField}
                componentProps={{
                  options: modulesOptions,
                }}
                controlProps={{
                  required: true,
                  label: 'Module',
                }}
              />
            </div>

            <div className={styles.actions}>
              <Button
                className={styles.action}
                size="md"
                variant="outlined"
                onClick={onClose}
              >
                {getTranslation('common.button.cancel')}
              </Button>
              <Button
                className={styles.action}
                startIcon={
                  copyLoading && (
                    <Loading color={'var(--color-white-primary)'} />
                  )
                }
                type="submit"
                size="md"
              >
                Copy
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    )}
  </Drawer>
);

export default React.memo(CopySettings) as any;
